// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary_primary__ssYB8","submenu":"primary_submenu__68yqL","on":"primary_on__fADIh","social":"primary_social__he_XI"};